<template>
  <v-container>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <template v-slot:activator="{ on }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipOn }">
            <v-btn color="info" fab small dark v-on="{ ...on, ...tooltipOn }">
              <v-icon style="font-size: 26px;">attach_money</v-icon></v-btn
            >
          </template>
          <span>Set Waiver</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-card color="primary" flat>
          <v-card-title>
            <span class="headline white--text">Set Waiver</span>
            <v-spacer></v-spacer>
            <v-btn
              fab
              class="ma-0 pa-0"
              small
              color="red white--text"
              @click="clearData()"
            >
              <v-icon medium>close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Student Name*"
                  v-model="item.std_name"
                  disabled
                ></v-text-field>
              </v-flex> 
              <v-flex xs12>
                <v-text-field
                  label="Nu Fee*"
                  v-model="item.total_fee"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Waiver Amount*"
                  type="number"
                  v-model="waiver"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Remarks"
                  v-model="remarks"
                  rows="3"
                  auto-grow
                  outlined
                  placeholder="Enter remarks..."
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary  white--text" @click="waiverInfo(waiver)"
              >submit</v-btn
            >
            <!-- <v-btn color="error  white--text" @click="clearBox()">Reset</v-btn> -->
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      waiver: "",
      remarks: "",
    };
  },
  methods: {
    waiverInfo(waiver) {
      let peram = {
        form_fill_up_id: this.item.papers[0].form_fill_up_id,
        waiver: waiver,
        remarks:this.remarks,
      };
      console.log("Tanvir! this is waiver amount", peram);
      if (waiver) {
        this.$store.dispatch("setWaiverAmount", peram).then((data) => {
          this.waiver = "";
          this.remarks= '';
          this.dialog = true;
          console.log("Tanvir! called", data);
        });
      }
    },

    clearData() {
      this.waiver = "";
      this.remarks= '';
      this.dialog = false;
    },
  },
};
</script>
<style lang=""></style>
